import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { NavService } from '../../services/nav.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  btnClicked: boolean = false;
  USER_ROLE: string = AuthService.USER_ROLE;
  ua: string;

  @Output() menuClose = new EventEmitter();

  constructor(
    public auth: AuthService,
    public nav: NavService,
  ) {
    const ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      this.ua = 'sp';
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      this.ua = 'tab';
    } else {
      this.ua = 'pc';
    }
  }

  ngOnInit() {
    this.btnClicked = false;
  }

  public onMenuClose = () => {
    if (this.btnClicked === true) {
      this.btnClicked = false;
      return;
    }

    this.menuClose.emit();
  }

  public onButtonClick = () => {
    this.btnClicked = true;
  }

  signOut() {
    this.auth.signOut();
  }

  getSupportPageLink() {
    if (this.auth.user.role === AuthService.VTUBER_ROLE && this.auth.user.is_public !== false) {
      return "/support/" + this.auth.user.uid;
    }

    return "";
  }
}
